// Layout do app (rota pathless _app): SidebarProvider + AppSidebar + área de conteúdo (Outlet).
// Desktop: sidebar colapsável à esquerda. Mobile: sidebar some e a navegação vira uma
// bottom bar flutuante (MobileBottomNav) — o conteúdo ganha padding inferior para não
// ficar escondido atrás dela, na medida que --mobile-nav-space (index.css) define.
import { useEffect, useState } from "react";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./app-sidebar.js";
import { MobileBottomNav } from "./mobile-nav.js";
import { GraceBanner } from "./grace-banner.js";
import { WhatsNewDialog } from "./whats-new-dialog.js";
import { isCallWorkspacePath } from "./lib/call-workspace.js";
import { useActiveBrandColor, useBrandColor } from "./brand.js";

export function AppLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  // White label: a cor da marca ativa vale para o app inteiro, inclusive o que
  // é renderizado em portal (diálogos, selects), porque entra como variável no
  // <html>. Mora aqui, e não na sidebar, para não depender de uma tela que o
  // mobile esconde.
  useBrandColor(useActiveBrandColor());
  const isCallWorkspace = isCallWorkspacePath(pathname);
  const [sidebarOpen, setSidebarOpen] = useState(() => !isCallWorkspace);

  useEffect(() => {
    if (isCallWorkspace) setSidebarOpen(false);
  }, [isCallWorkspace, pathname]);

  return (
    <SidebarProvider open={sidebarOpen} onOpenChange={setSidebarOpen}>
      <AppSidebar />
      {/* min-w-0: o wrapper da sidebar é um flex row de largura 100%, e o inset
          entra nele com w-full. Sem isso o inset herda min-width:auto e não
          encolhe abaixo do conteúdo mais largo da tela — o gap da sidebar é
          espremido e a linha estoura o viewport, criando uma barra de rolagem
          horizontal global. Telas largas (o Quadro) já rolam por dentro. */}
      <SidebarInset className="min-w-0 pb-(--mobile-nav-space) md:pb-0">
        <GraceBanner />
        <Outlet />
      </SidebarInset>
      <MobileBottomNav />
      {/* Convite para o changelog da landing. Mora aqui para aparecer uma
          vez por carregamento do app em vez de a cada navegação. */}
      <WhatsNewDialog />
    </SidebarProvider>
  );
}
